import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { Person } from '../../../models/Entities/Person/Person';

// store
import * as PersonsStore from '../../../redux/middleware/Persons.Middleware';

export interface ConnectedProps {
  PersonId: number;
  Person: Person | undefined;
  isPersonLoading: boolean | undefined;
  failOnLoadingPerson: boolean | undefined;
  error: ErrorType | undefined;
}

interface DispatchProps {
  GetPersonById: typeof PersonsStore.actionCreators.GetPersonById;
}

export type Props = ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: any) => {
  const PersonId: number = Number(ownProps.match.params?.PersonId);

  return {
    PersonId: PersonId,
    Person: state.Persons?.list.find((person: Person) => person.id === PersonId),

    //states
    isPersonLoading: state.Persons?.isLoadingOne,
    failOnLoadingPerson: state.Persons?.failOnLoadingOne,
    error: state.Persons?.error
  };
};

export const mapDispatchToProps = {
  ...PersonsStore.actionCreators
};
